/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reporting_UsageInputs */



/**
* | output |
* | --- |
* | "Reporting & Usage" |
*
* @param {Reporting_UsageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reporting_usage = /** @type {((inputs?: Reporting_UsageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reporting_UsageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rapports et utilisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Berichterstattung & Nutzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segnalazione e utilizzo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отчетность и использование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Informes y uso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("报告与使用情况")
	if (locale === "ja") return /** @type {LocalizedString} */ ("報告と使用状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिपोर्टिंग और उपयोग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Relatórios e Utilização")
	return /** @type {LocalizedString} */ ("Reporting & Usage")
});